import { h } from 'preact'

import translations from '../../../libs/translationsUtils/translations'
import Analytics from '../../analytics/Analytics'
import Icon from '../../assets'
import { SearchQuery } from './Search'

const eventTracker = () => {
  Analytics.send('Homepage', 'Search clicked')
}

const doSearch = (searchValue: string) => {
  if (!searchValue) return
  window.location.href = `/search?q=${searchValue}`
}

const getSearchQueryFromInput = (searchString: string) => {
  let searchQuery : SearchQuery = { q: searchString }
  let eventUrlPattern = /https?:\/\/.+\/events\/.+-(\d+)$/
  let eventUrl = eventUrlPattern.exec(searchString)

  if (eventUrl !== null) {
    searchQuery.q = eventUrl[1]
    searchQuery.contentType = 'event'
  }

  let m = /https?:\/\/.+\/.+-\d+\/.+-(\d+)$/.exec(searchString)
  if (m !== null) {
    searchQuery.q = m[1]
  }

  return searchQuery
}

interface Props {
  reset?: () => void,
  refine?: (query: string) => void,
  setHighlightedIndex?: (index: number | null) => void,
  inputValue?: string,
  getInputProps?: (attrs: {onChange: OnChangeCallback, onSubmit: OnSubmitCallback, onFocus: OnFocusCallback}) => object,
  openMenu?: () => void,
  isOpen?: boolean,
  isControl?: boolean,
  placeholder?: string,
  updateSearch?: (query: SearchQuery, cb: () => void) => void
  submitIconType: string
}

const noop = () => ({})

const submitIcon = (type: string) => {
  switch (type) {
    case 'add':
      return (
        <Icon icon='add' width={16} height={16} color={'currentColor'} />
      )
    default:
      return (
        <Icon icon='search' width={16} height={16} color={'currentColor'} />
      )
  }
}

const SearchBox = ({
  reset = noop,
  refine = noop,
  setHighlightedIndex = noop,
  inputValue = '',
  getInputProps = noop,
  openMenu = noop,
  isOpen = false,
  isControl = false,
  placeholder = '',
  updateSearch = noop,
  submitIconType
}: Props) => <div class='search-box'>
  <input
    type='search'
    placeholder={isControl ? placeholder : translations.translate('Forum', 'live.search.placeholder')}
    autocomplete='off'
    autocorrect='off'
    autocapitalize='off'
    className={`search-box__input ${inputValue && isOpen ? 'search-box__input--focused' : ''}`}
    {...getInputProps({
      onChange (e: {target: HTMLInputElement}) {
        let searchQuery = getSearchQueryFromInput(e.target.value)
        updateSearch(searchQuery, () => {
          refine(searchQuery.q)
          setHighlightedIndex(null)
        })
      },
      onSubmit (e: Event) {
        e.preventDefault()
        doSearch(inputValue)
      },
      onFocus: () => {
        eventTracker()
        openMenu()
      }
    })}
  />
  <button type='submit' class='search-box__submit' onClick={(e) => { e.preventDefault(); doSearch(inputValue) }}>
    {submitIcon(submitIconType)}
  </button>
  <button type='reset' class='search-box__reset' onClick={() => reset()} style={{ opacity: inputValue ? 1 : 0 }}>
    <Icon icon='close' width={16} height={16} color={'currentColor'} />
  </button>
</div>

export { SearchBox, doSearch }
